import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type DashboardState = {
	dashboard: {
		settlements: any;
		timeSpan: string;
		chartData: any;
		dateRange: DateRangeType;
	};
};

type DateRangeType = {
	fromDate: string;
	toDate: string;
};

export const timeSpanOptions = [
	{
		value: 'monthly',
		label: 'Monthly',
	},
	{
		value: 'weekly',
		label: 'Weekly',
	},
	{
		value: 'daily',
		label: 'Daily',
	},
];

type DashboardActions = {
	setTimeSpan: (timeSpan: Partial<DashboardState['dashboard']['timeSpan']>) => void;
	setDateRange: (dateRange: DashboardState['dashboard']['dateRange']) => void;
	setChartData: (chartData: DashboardState['dashboard']['chartData']) => void;
	setDashboardSettlements: (settlements: Partial<DashboardState['dashboard']['settlements']>) => void;
};

export type DashboardSlice = DashboardState & DashboardActions;

const dashboardInitialState: DashboardState = {
	dashboard: {
		settlements: [],
		timeSpan: 'monthly',
		chartData: [],
		dateRange: {
			fromDate: '',
			toDate: '',
		},
	},
};

export function dashboardSlice(set: NamedSet<ZustandStore>): DashboardSlice {
	return {
		...dashboardInitialState,
		setDashboardSettlements(settlements: Partial<DashboardState['dashboard']['settlements']>): void {
			set(
				(state: DashboardState) => {
					state.dashboard.settlements = settlements;
					return state;
				},
				false,
				'[setDashboardSettlements]',
			);
		},
		setTimeSpan(timeSpan: Partial<DashboardState['dashboard']['timeSpan']>): void {
			set(
				(state: DashboardState) => {
					state.dashboard.timeSpan = timeSpan;
					return state;
				},
				false,
				'[setTimeSpan]',
			);
		},
		setDateRange(dateRange: DashboardState['dashboard']['dateRange']): void {
			set(
				(state: DashboardState) => {
					state.dashboard.dateRange = dateRange;
					return state;
				},
				false,
				'[setDateRange]',
			);
		},
		setChartData(chartData: DashboardState['dashboard']['chartData']): void {
			set(
				(state: DashboardState) => {
					state.dashboard.chartData = chartData;
					return state;
				},
				false,
				'[setChartData]',
			);
		},
	};
}
